import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const projects = [
  {
    name: "Janani & Bachpan",
    slug: "janani",
    url: "https://jananibachpan.com",
    tag: "AI App · Healthcare",
    desc: "An AI companion for pregnancy & motherhood — multilingual chat, guidance and care, built for Indian mothers.",
    image:
      "https://images.pexels.com/photos/17195067/pexels-photo-17195067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "ACE AI Apps",
    slug: "ace-ai",
    url: null,
    tag: "AI Agents · Productivity",
    desc: "A suite of domain-specific AI agents that automate research, support and operations for growing teams.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export default function Portfolio() {
  return (
    <section id="work" className="py-24 relative border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-neon-cyan mb-3">// selected work</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter">
            Products we've shipped.
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {projects.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <Link
                to={`/work/${p.slug}`}
                data-testid={`portfolio-card-${i}`}
                className="group block glow-border relative overflow-hidden rounded-2xl border border-neon-cyan/15 bg-surface"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface to-transparent" />
                </div>
                <div className="p-7">
                  <p className="font-mono text-xs uppercase tracking-wider text-neon-cyan">{p.tag}</p>
                  <h3 className="mt-2 text-2xl font-bold tracking-tight">{p.name}</h3>
                  <p className="mt-2 text-sm text-white/55 leading-relaxed">{p.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-neon-cyan group-hover:gap-2 transition-all">
                    Read case study <ArrowRight size={16} />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
